'use strict';

/**
 * All JS for any action of the ProfileApplications on the server side
 */
waApp.controllers.ArchitellerApplications = {
	index: function() {
		// Check if company is present
		if ($('#country-id').length) {
			let countryInput = $('#company-country-id');

			countryInput.select2({
				placeholder: countryInput.attr('placeholder'),
				allowClear: true
			});

			waUtils.stateSelect('#company-country-id');
		}

		$('#limited-resources').select2({});
		$('#climate-change').select2({});
		$('#social-responsibility').select2({});
	}
};
